import * as React from 'react';
import Box from '@mui/material/Box';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import HomeIcon from '@mui/icons-material/Home';
import logo from "../../assets/logo.png";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { Link, useLocation } from 'react-router-dom';
import { useRef } from 'react'
import { styled } from '@mui/material';
const Footer = () => {

    // styled
    // 定义中间按钮的样式
    const CenterButton = styled(BottomNavigationAction)(({ theme }) => ({
        // 在这里设置中间按钮的样式
        // 可以设置宽度、高度等
        // 这里只是一个示例
        flex: 'none', // 不要自动拉伸
        width: '10px', // 设置宽度
        top: '-50px',
        height: '100px', // 设置高度
    }));

    const rootRef = useRef(null); // 创建一个引用
    const [show, setShow] = React.useState("block");
    const [value, setValue] = React.useState(0);

    const h = document.body.scrollHeight;
    //监听页面尺寸变化
    window.addEventListener("resize", function () {
        // 解决键盘弹起后遮挡输入框的问题
        if (document.activeElement.tagName == "INPUT" || document.activeElement.tagName == "TEXTAREA") {
            window.setTimeout(function () {
                document.activeElement.scrollIntoViewIfNeeded();
            }, 0);
        }

        //解决键盘弹起把固定在底部的按钮顶上去的问题
        //btnSubmit是按钮区域的的节点id
        const bottomBtn = document.querySelector("#btnSubmit");
        if (document.body.scrollHeight < h) {
            setShow('none');
        } else {
            setShow('block');
        }
    })


    // const location =  useLocation();
    // React.useEffect(() => {
    //     if(location.pathname.includes('search'))
    //     {
    //         setShow('none');
    //     }
    //     else{
    //         setShow('block');
    //     }

    // }, [location]); 


    return (
        <Box ref={rootRef} className='w-full fixed bottom-0 left-0 bg-slate-100' sx={{ display: show, zIndex: 99, backgroundColor: 'rgba(255, 255, 255, 0.75)', width: "90%", bottom: "10px", left: "5%",borderRadius:"10px", paddingBottom: 'env(safe-area-inset-bottom)' }}>
            <BottomNavigation
                showLabels
                value={value}
                onChange={(event, newValue) => {
                    setValue(newValue);
                }}
                sx={{background:'transparent',height:'48px'}}
            >
                <BottomNavigationAction label="首页" icon={<HomeIcon />} component={Link} to="/home" />
                <CenterButton icon={<img src={logo} ></img>} />
                <BottomNavigationAction label="我的" icon={<AccountCircleIcon />} component={Link} to="/my" />
            </BottomNavigation>
        </Box>
    );
};

export default Footer;